module.exports = __webpack_public_path__ + "img/no_img.0ea197b7.png";